import { AbridgeWordmark } from './AbridgeWordmark';
import './sidebar-branding.css';

export function VibesWordmark({ onClick }: { onClick: () => void }) {
  return <button type="button" className="vibes-wordmark" aria-label="Vibes — Start Here" onClick={onClick}>
    <span className="vibes-wordmark-front" aria-hidden="true">
      <span className="vibes-wordmark-mark"><i /><i /><i /><i /></span>
      <span className="vibes-wordmark-text">Vibes</span>
    </span>
    <span className="vibes-wordmark-abridge" aria-hidden="true">
      <span className="vibes-wordmark-made-for">Made for</span>
      <AbridgeWordmark />
    </span>
  </button>;
}
